import moment from 'moment';
import { useEffect, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { getOrderHistory } from '../../apis/orders';
import { getCustomers } from '../../apis/user';
import { H6 } from '../../components/H6';
import { Table } from '../../components/Table';
import { CustomerBoardList, OrderSummary } from '../../types/types';

export const MyPageHome = () => {
  const { push } = useHistory();
  const [orders, setOrders] = useState<OrderSummary[]>([]);
  const [customers, setCustomers] = useState<CustomerBoardList[]>([]);

  useEffect(() => {
    getOrderHistory(0, 3).then(r => setOrders(r?.data.payload.content || [])).catch(e => console.log(e));
    getCustomers(0, 5).then(r => setCustomers(r?.data.payload.content || [])).catch(e => console.log(e));
  }, []);

  return (
    <div className="hidden md:block">
      <div className="mb-10">
        <div className="flex justify-between items-center">
          <H6 className="">최근 주문 내역</H6>
          <Link to="/mypage/orders" className="text-13">
            전체보기
          </Link>
        </div>
        {orders.length === 0 ? (
          <div className={'py-20 center text-center'}>
            <p>최근 주문 내역이 없습니다.</p>
          </div>
        ) : (
          <Table className="mt-5 border-b">
            <Table.Head>
              <Table.Row>
                <Table.Th>스토어명</Table.Th>
                <Table.Th>주문일자</Table.Th>
                <Table.Th>주문번호</Table.Th>
                <Table.Th>상품</Table.Th>
                <Table.Th>총 결제금액</Table.Th>
              </Table.Row>
            </Table.Head>
            <Table.Body>
              {orders.map((apply, index) => (
                <Table.Row key={index}>
                  <Table.Td>{apply.store}</Table.Td>
                  <Table.Td>
                    {moment(apply.orderedAt).format(`YYYY.MM.DD`)}
                  </Table.Td>
                  <Table.Td className="font-bold">
                    <Link to={`/mypage/orders/${apply.orderNumber}`}>
                      {apply.orderNumber} {`>`}
                    </Link>
                  </Table.Td>
                  <Table.Td>
                    <div
                      className="flex space-x-4 font-normal items-center m-3"
                      key={index}>
                      <div className="w-20 h-24 relative rounded-lg overflow-hidden">
                        <img
                          src={apply.products[0].thumbnailUrl}
                          alt=""
                          className="w-full h-full object-cover absolute"
                        />
                      </div>
                      <div className="text-14 font-bold text-brand-3 min-w-0">
                        <p className="text-brand-1">
                          {apply.products[0].productName}
                        </p>
                        <p className="">{apply.products[0].color}</p>
                        <p className="">사이즈 {apply.products[0].sizeName}</p>
                        <p className="pt-2">외 {apply.products.length - 1}건</p>
                      </div>
                    </div>
                  </Table.Td>

                  <Table.Td className="font-bold">
                    {apply.totalPrice.toLocaleString()}원
                  </Table.Td>
                </Table.Row>
              ))}
            </Table.Body>
          </Table>
        )}
      </div>

      {/*<div>*/}
      {/*  <H6 className="mt-16">나의 문의</H6>*/}

      {/*  {customers.length === 0 ? (*/}
      {/*    <div className={'py-20 center text-center'}>*/}
      {/*      <p>나의 문의 내역이 없습니다.</p>*/}
      {/*    </div>*/}
      {/*  ) : (*/}
      {/*    <Table className="mt-5">*/}
      {/*      <Table.Head>*/}
      {/*        <Table.Row>*/}
      {/*          <Table.Th>No.</Table.Th>*/}
      {/*          <Table.Th>제목</Table.Th>*/}
      {/*          <Table.Th>문의일</Table.Th>*/}
      {/*          <Table.Th>문의 답변일</Table.Th>*/}
      {/*          <Table.Th>답변 여부</Table.Th>*/}
      {/*          <Table.Th></Table.Th>*/}
      {/*        </Table.Row>*/}
      {/*      </Table.Head>*/}
      {/*      <Table.Body>*/}
      {/*        {customers.map((inquiry, index) => (*/}
      {/*          <Table.Row key={index}>*/}
      {/*            <Table.Td>{inquiry.customerBoardId}</Table.Td>*/}
      {/*            <Table.Td>{inquiry.title}</Table.Td>*/}
      {/*            <Table.Td>*/}
      {/*              {moment(inquiry.createdAt).format(`YYYY.MM.DD`)}*/}
      {/*            </Table.Td>*/}
      {/*            <Table.Td>*/}
      {/*              {inquiry.repliedAt*/}
      {/*                ? moment(inquiry.repliedAt).format(`YYYY.MM.DD`)*/}
      {/*                : '-'}*/}
      {/*            </Table.Td>*/}
      {/*            <Table.Td*/}
      {/*              className={`${inquiry.isReplied ? 'text-gray-400' : ''}`}>*/}
      {/*              {inquiry.isReplied ? '답변 완료' : '답변 대기'}*/}
      {/*            </Table.Td>*/}
      {/*            <Table.Td*/}
      {/*              className={'text-blue-500 cursor-pointer'}*/}
      {/*              onClick={() =>*/}
      {/*                push(`/mypage/inquire/${inquiry.customerBoardId}`)*/}
      {/*              }>*/}
      {/*              상세보기*/}
      {/*            </Table.Td>*/}
      {/*          </Table.Row>*/}
      {/*        ))}*/}
      {/*      </Table.Body>*/}
      {/*    </Table>*/}
      {/*  )}*/}
      {/*</div>*/}
      <div className="pb-20" />
    </div>
  );
};
